import React, { createContext, useContext, useState } from 'react';

const FormModalContext = createContext(null);

export const FormModalProvider = ({ children }) => {
    const [showForm, setShowForm] = useState(false);

    const openForm = () => setShowForm(true);
    const closeForm = () => setShowForm(false);

    return (
        <FormModalContext.Provider value={{ showForm, setShowForm, openForm, closeForm }}>
            {children}
        </FormModalContext.Provider>
    );
};

export const useFormModal = () => {
    const context = useContext(FormModalContext);
    if (!context) {
        throw new Error('useFormModal must be used within FormModalProvider');
    }
    return context;
};
